import { Box } from "@mui/joy";
import { AnimatePresence, motion } from "framer-motion";
import { Outlet, useLocation } from "react-router-dom";

export default function GeneralWrapper() {
    const location = useLocation();

    return (
        // <AnimatePresence mode="wait">
        //     <motion.div
        //         key={location.pathname}
        //         initial={{ opacity: 0, x: -20 }}
        //         animate={{ opacity: 1, x: 0 }}
        //         exit={{ opacity: 0, x: -20 }}
        //         transition={{ duration: 0.2 }}
        //         style={{ width: "100%", display: "flex" }}
        //     >
        <Outlet />
        //     </motion.div>
        // </AnimatePresence>
    );
}
